import { ChangeEventHandler, FC } from "react"

interface IProps {
  title?: string
  value?: string
  onChange?: ChangeEventHandler<HTMLTextAreaElement>
  placeholder?: string
  disabled?: boolean
  id?: string
  name?: string
  rows?: number
  invalid?: boolean
  hint?: string
  required?: boolean
}

export const TextareaField: FC<IProps> = ({
  title,
  value,
  onChange,
  placeholder,
  disabled,
  id,
  name,
  rows = 3,
  invalid,
  hint,
  required
}) => (
  <div className="w-full form-control">
    {title && (
      <label className="label" htmlFor={id}>
        <span className={`label-text ${invalid ? "text-error" : ""}`}>{title}</span>
      </label>
    )}
    <textarea
      rows={rows}
      value={value}
      required={required}
      onChange={onChange}
      placeholder={placeholder}
      disabled={disabled}
      className={`w-full textarea textarea-bordered bg-[rgba(0,0,0,0.05)] dark:bg-[rgba(0,0,0,0.2)] ${invalid ? "textarea-error" : ""}`}
      {...(id && { id })}
      {...(name && { name })}
    />
    {hint && (
      <label className="label">
        <span className={`label-text-alt ${invalid ? "text-error" : ""}`}>{hint}</span>
      </label>
    )}
  </div>
)
